import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import fallback from '../../assets/fallback_store_logo.jpeg'

/**
 * Un componente de imagen que muestra un fallback si la imagen original (src) falla.
 * Usa styled-components (no clases de Tailwind) porque la app no procesa
 * Tailwind sobre su propio CSS: solo existen las utilities que compila el
 * paquete ui, y depender de eso es frágil.
 * @param {string} fallback - La fuente de la imagen de fallback.
 * @param {string} src - La fuente de la imagen original.
 * @param {object} rest - Cualquier otra prop de <img> (como className, style, width, height).
 */
export function StoreLogoWithFallback({ src, ...rest }) {
  const [image, setImage] = useState(null)

  useEffect(() => {
    const img = new Image()
    img.src = src

    img.onload = () => setImage(src)
    img.onerror = () => setImage(fallback)
  }, [fallback, src])

  return (
    <LogoContainer>
      <img src={image} {...rest} />
    </LogoContainer>
  )
}

const LogoContainer = styled.div`
  margin-top: 1.5rem;
  height: clamp(7rem, 30vmin, 13rem);
  width: clamp(7rem, 30vmin, 13rem);

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`

StoreLogoWithFallback.propTypes = {
  src: PropTypes.string.isRequired,
}
